import { render, staticRenderFns } from "./Tinymceedit.vue?vue&type=template&id=057b1dd8&scoped=true"
import script from "./Tinymceedit.vue?vue&type=script&lang=js"
export * from "./Tinymceedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b1dd8",
  null
  
)

export default component.exports